import React from "react";
import "react-datetime/css/react-datetime.css";

function TimeInput({
  name,
  id,
  label,
  ariaLabel = "",
  value = "",
  handleChange,
  required = false,
  disabled,
  errorMessage,
  maxLength,
  cName,
  placeholder,
  "aria-label": ariaLabelProp,
  "aria-required": ariaRequiredProp,
}) {
  const isRequired = ariaRequiredProp !== undefined ? ariaRequiredProp : required;
  const ariaLabelText =
    ariaLabelProp ||
    ariaLabel ||
    (typeof label === "string" && label.trim() ? label.trim() : "") ||
    (typeof placeholder === "string" && placeholder.trim() ? placeholder.trim() : "") ||
    (typeof name === "string" && name.trim() ? name.trim() : "") ||
    "Select time";

  return (
    <>
      {label && (
        <label
          htmlFor={id || name}
          className="form-label col-form-label w-100 fs-5 form-label-custom-visible"
        >
          {label} {isRequired && <span className="text-danger">*</span>}
        </label>
      )}

      <div>
        <input
          type="time"
          className={`form-control ${cName} ${errorMessage?.[name]?.trim()?.length > 0 ? "input-error" : ""}`}
          name={name}
          id={id || name}
          value={value || ""}
          onChange={handleChange}
          required={isRequired}
          aria-label={ariaLabelText}
          aria-required={isRequired}
          disabled={disabled}
          placeholder={placeholder || ""}
          maxLength={maxLength}
        />
        <i
          className="bi bi-clock-fill position-absolute"
          style={{
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            color: "#6c757d",
          }}
          aria-hidden="true"
        ></i>
      </div>
      {errorMessage && errorMessage[name] && Object?.keys(errorMessage).length > 0 && (
        <div className="text-danger fw-700 fs-6">
          {errorMessage && errorMessage[name] && errorMessage[name]}
        </div>
      )}
    </>
  );
}

export default TimeInput;
